import axios from 'utils/axios';
import { HttpMethod } from 'types/Enums';

export const apiCall = async <T = any,>(endpoint: string, method: HttpMethod, data?: unknown): Promise<T> => {
  const timeout: number = 30000; // 30 sec
  try {
    const response = await axios.request<T>({
      method,
      url: endpoint,
      data,
      timeout: timeout
    });

    return response.data;
  } catch (error) {
    console.log(`Endpoint: ${endpoint}, Method: ${method} returned error:`, error);
    throw error;
  }
};
